import { Home, Menu, Plus } from 'lucide-react';

// Keep the website and app introduction aligned with the main navigation.
const AppNavigationPreview = () => (
  <div className="grid grid-cols-3 items-end rounded-2xl border border-zinc-200 bg-white px-2 pb-3 pt-5 text-center text-[10px] text-zinc-500 dark:border-zinc-800 dark:bg-zinc-950 dark:text-zinc-400" role="img" aria-label="Appnavigatie: Overzicht, Toevoegen en Meer">
    <span className="flex flex-col items-center gap-1.5"><Home className="h-5 w-5" aria-hidden="true" />Overzicht</span>
    <span className="-mt-7 flex flex-col items-center gap-1.5 text-primary"><span className="grid h-12 w-12 place-items-center rounded-full bg-primary text-white shadow-md shadow-primary/20"><Plus className="h-7 w-7" strokeWidth={2.5} aria-hidden="true" /></span><span className="font-semibold">Toevoegen</span></span>
    <span className="flex flex-col items-center gap-1.5"><Menu className="h-5 w-5" aria-hidden="true" />Meer</span>
  </div>
);

export default AppNavigationPreview;
